<template>
  <div style="height: 100%;">
    <v-row align="center" justify="center" style="height: 100%;">
      <v-col cols="auto">
        <spinner-cadu
          :line-fg-color="$vuetify.theme.themes.light.primary1"
          :size="100"
          :line-size="5"
          :speed="0.6"
          :font-size="40"
          :spacing="10"
          message="Carregando"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'

import Usuario from '../services/Usuario'

export default {
  mounted() {
    axios
      .get(this.CriarUrl({ resource: '/login', params: this.configurarDados() }, { adicionarAuth: true }))
      .then((res) => {
        const tokenBearer = res.headers.authorization
        localStorage.setItem('auth_cadu', tokenBearer)
        localStorage.setItem('user_cadu', JSON.stringify(res.data))

        new Usuario(this.tokenBearer, this.$appConfig.config.API)
          .getTokenLegado()
          .then(({ data }) => localStorage.setItem('tokenBearer', data))
          .finally(() => {
            this.$router.push({
              name: 'home',
              params: { tokenBearer: res.headers.authorization }
            })
            this.$emit('loading')
          })
      })
      .catch(() => this.$router.push('/erro'))
  },
  methods: {
    configurarDados() {
      let authCode, codigoUnimed
      const { code, state } = this.$route.query
      authCode = code
      const params = new URLSearchParams(state)
      codigoUnimed = params.get('codigoUnimed')
      return { authCode, codigoUnimed }
    }
  }
}
</script>
